export const PATH =
  process.env.REACT_APP_ELECTION_PATH ||
  'https://pre-elecciones.atresmedia.com/cmselections/'; // IP de Juan  prek8scms.atresmedia.com // 10.1.1.85:8080  // pro https://elecciones.atresmedia.com/cmselections/

export const ELECTION_SPAIN_GENERAL_EUROPE = 'C108';

export const CODE_CANARY = 'R05';

export const PLACE_ID =
  process.env.REACT_APP_PLACE_ID || ELECTION_SPAIN_GENERAL_EUROPE;

export const TYPES = {
  GENERAL: 'GENERAL',
  REGIONAL: 'REGIONAL',
  MUNICIPAL: 'MUNICIPAL',
  EUROPEAN: 'EUROPEAN'
};

export const SUBTYPES = {
  CONGRESS: 'CONGRESS',
  SENATE: 'SENATE',
  SINGLE: 'SINGLE',
  INSULAR: 'INSULAR',
  REGIONAL: 'REGIONAL',
  AUTONOMIC: 'AUTONOMIC'
};

export const communitiesIds = {
  ANDALUCIA: 'R01',
  ARAGON: 'R02',
  ASTURIAS: 'R03',
  BALEARES: 'R04',
  CANARIAS: 'R05',
  CANTABRIA: 'R06',
  CASTILLA_Y_LEÓN: 'R07',
  CASTILLA_LA_MANCHA: 'R08',
  CATALUÑA: 'R09',
  COMUNITAT_VALENCIANA: 'R10',
  EXTREMADURA: 'R11',
  GALICIA: 'R12',
  COMUNIDAD_DE_MADRID: 'R13',
  REGIÓN_DE_MURCIA: 'R14',
  COMUNIDAD_FORAL_DE_NAVARRA: 'R15',
  PAÍS_VASCO: 'R16',
  LA_RIOJA: 'R17',
  CEUTA: 'R18',
  MELILLA: 'R19'
};

window.__debug__ = process.env.REACT_APP_DEBUG || false;
